import { ArrowRight, ChartNoAxesCombined } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import { Button } from '../../components/ui/Button'
import { PageHeader } from '../../components/ui/PageHeader'
import { LEARNING_TASKS } from '../../data/dashboardData'
import { useAppState } from '../../state/AppState'

export function ReportsPage() {
  const navigate = useNavigate()
  const { completedTaskIds } = useAppState()
  const completionRate = Math.round(
    (completedTaskIds.size / LEARNING_TASKS.length) * 100,
  )

  return (
    <div className="content-page">
      <PageHeader
        title="学习报告"
        description="报告只基于真实任务、作答和复习记录生成。"
      />

      <section className="report-progress">
        <div className="report-progress__copy">
          <ChartNoAxesCombined size={28} strokeWidth={1.5} aria-hidden="true" />
          <div>
            <h2>首周准备进度</h2>
            <p>完成入学诊断后，将生成知识掌握、错因和下周计划。</p>
          </div>
        </div>
        <strong>{completionRate}%</strong>
        <div className="progress-track" aria-label={`首周准备进度 ${completionRate}%`}>
          <span style={{ width: `${completionRate}%` }} />
        </div>
      </section>

      <section className="report-placeholder">
        <h2>目前还没有足够的学习证据</h2>
        <p>至少完成入学诊断和一周任务后，系统才会生成趋势与建议。</p>
        <Button onClick={() => navigate('/today')}>
          返回今日任务
          <ArrowRight size={17} aria-hidden="true" />
        </Button>
      </section>
    </div>
  )
}
